import type { InviteOnboardingStep, PersistedInviteState } from "@/frontend/types/invite";

export const INVITE_RESUME_STORAGE_KEY = "connect:invite-resume-id";
export const INVITE_AUTH_FLOW_HEADER = "x-connect-auth-flow";
export const INVITE_AUTH_FLOW_SIGNUP = "invite-signup";

export function rememberInviteResumeId(invitationId: string) {
  if (!invitationId || typeof window === "undefined") return;
  window.sessionStorage.setItem(INVITE_RESUME_STORAGE_KEY, invitationId);
}

export function getRememberedInviteResumeId(): string | null {
  if (typeof window === "undefined") return null;
  const value = window.sessionStorage.getItem(INVITE_RESUME_STORAGE_KEY);
  return value && value.trim() ? value : null;
}

export function clearInviteResumeId(invitationId?: string | null) {
  if (typeof window === "undefined") return;
  if (!invitationId) {
    window.sessionStorage.removeItem(INVITE_RESUME_STORAGE_KEY);
    return;
  }
  if (window.sessionStorage.getItem(INVITE_RESUME_STORAGE_KEY) === invitationId) {
    window.sessionStorage.removeItem(INVITE_RESUME_STORAGE_KEY);
  }
}

const inviteStateKey = (invitationId: string) => `invite_state_${invitationId}`;

/** Reads persisted invite-onboarding step + name from localStorage. */
export function getInviteStateFromLocalStorage(invitationId: string): PersistedInviteState {
  try {
    const raw = localStorage.getItem(inviteStateKey(invitationId));
    if (raw) return JSON.parse(raw);
  } catch {}
  return { step: "name-email", name: "" };
}

/** Persists the in-flight invite step + name so tab-switch remounts can restore. */
export function setInviteStateInLocalStorage(invitationId: string, step: InviteOnboardingStep, name: string) {
  localStorage.setItem(inviteStateKey(invitationId), JSON.stringify({ step, name }));
}

/** Clears persisted invite state — call after successful join. */
export function clearInviteStateFromLocalStorage(invitationId: string) {
  localStorage.removeItem(inviteStateKey(invitationId));
}
